import React from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtBytes, fmtDT } from "@/lib/platform";
import { downloadEvidence } from "@/lib/rights";
import { Panel } from "@/components/rights/RightsBadges";
import { EvidenceUploadButton } from "@/components/rights/EvidenceUploadButton";

const UPLOADABLE = ["CONTRACT", "DPA", "SECURITY_CERT", "OTHER"];

export const VendorEvidencePanel = ({ v, meta, canEdit, onChanged }) => (
  <Panel eyebrow="Universal evidence store" title={`Vendor evidence (${v.evidence.length})`} testId="vendor-evidence-panel"
         actions={canEdit && UPLOADABLE.map((k) => (
           <EvidenceUploadButton key={k} endpoint={`/vendors/${v.id}/evidence`} category={k} onUploaded={onChanged}
                                 label={meta.evidence_categories[k]} testId={`vendor-evidence-upload-${k.toLowerCase()}`} />
         ))}>
    {v.evidence.length === 0 ? <div className="text-xs text-slate-500">No evidence uploaded yet.</div> : (
      <ul className="divide-y divide-slate-100">
        {v.evidence.map((e) => (
          <li key={e.id} className="flex items-center gap-3 py-2.5 text-xs" data-testid={`vendor-evidence-${e.id}`}>
            <span className="font-mono text-slate-400">{e.reference_number}</span>
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">{e.category_label}</span>
            <span className="font-medium text-[#003366] truncate flex-1">{e.file_name}
              {e.control_key && <span className="text-slate-400 font-normal"> · {e.control_key.toLowerCase().replace(/_/g, " ")}</span>}
              {e.question_key && <span className="text-slate-400 font-normal"> · {e.question_key}</span>}</span>
            <span className="text-slate-500 hidden md:inline">{fmtBytes(e.file_size)} · {e.uploaded_by} · {fmtDT(e.uploaded_at)}</span>
            <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => downloadEvidence(e.id)} data-testid={`vendor-evidence-download-${e.id}`}>
              <Download className="w-3.5 h-3.5" /></Button>
          </li>
        ))}
      </ul>
    )}
  </Panel>
);
